import React, { useEffect, useState } from "react";
import "./SpecForm.scss";
import { ManagedInput } from "components/orders/Fields/Input/ManagedInput";
import type { PartialDecking } from "./SpecFormSchema";
import { useT } from "i18n";

interface PartialDeckingProps {
  setPartialDecking: (partialDecking: PartialDecking) => void;
  partialDecking: PartialDecking;
  archived?: boolean;
}

export interface partialDeckingValuesType {
  id: string;
  anchorTypeOptions?: string;
  cableAssembly?: boolean;
  isRemovable?: boolean;
  stepFastener?: string;
  isCovered?: boolean;
  isOverWater?: boolean;
  notes?: string;
}

const PartialDeckingFeat = ({
  partialDecking,
  setPartialDecking,
  archived,
}: PartialDeckingProps) => {
  const t = useT();
  // Field states
  const [partialDeckingLength, setPartialDeckingLength] = useState<string | undefined>(
    partialDecking?.partialDeckingLength?.toString(),
  );
  const [partialDeckingType, setPartialDeckingType] = useState<string | undefined>(
    partialDecking?.partialDeckingType,
  );
  const [partialDeckingFeatureId, setPartialDeckingFeatureId] = useState<
    string | undefined
  >(partialDecking?.partialDeckingFeatureId);
  const [partialDeckingPaddingLength, setPartialDeckingPaddingLength] = useState<
    string | undefined
  >(partialDecking?.partialDeckingPaddingLength?.toString());
  const [partialDeckingPaddingFeatureId, setPartialDeckingPaddingFeatureId] = useState<
    string | undefined
  >(partialDecking?.partialDeckingPaddingFeatureId);

  useEffect(() => {
    setPartialDecking({
      partialDeckingLength: parseInt(partialDeckingLength ?? "0"),
      partialDeckingType: partialDeckingType ?? "",
      partialDeckingFeatureId: partialDeckingFeatureId ?? "",
      partialDeckingPaddingLength: parseInt(partialDeckingPaddingLength ?? "0"),
      partialDeckingPaddingFeatureId: partialDeckingPaddingFeatureId ?? "",
    });
  }, [
    partialDeckingLength,
    partialDeckingType,
    partialDeckingFeatureId,
    partialDeckingPaddingLength,
    partialDeckingPaddingFeatureId,
  ]);

  return (
    <>
      <div className={"spec-form__second-title"}>
        {t("component.forms.spec.deckingLabel", "Decking: {{type}}", {
          type: partialDeckingType,
        })}
      </div>
      <ManagedInput
        isValid={true}
        label={t("component.forms.spec.partialDeckingLength", "Partial Decking Length")}
        type={"text"}
        placeholder={t(
          "component.forms.spec.partialDeckingLength",
          "Partial Decking Length",
        )}
        onChange={setPartialDeckingLength}
        value={partialDeckingLength}
        disabled={archived}
      />
      <ManagedInput
        isValid={true}
        label={t("component.forms.spec.partialDeckingType", "Partial Decking Type")}
        type={"text"}
        placeholder={t(
          "component.forms.spec.partialDeckingType",
          "Partial Decking Type",
        )}
        onChange={setPartialDeckingType}
        value={partialDeckingType}
        disabled={archived}
      />
      <ManagedInput
        isValid={true}
        label={t(
          "component.forms.spec.partialDeckingFeatureId",
          "Partial Decking FeatureId",
        )}
        type={"text"}
        placeholder={t(
          "component.forms.spec.partialDeckingFeatureId",
          "Partial Decking FeatureId",
        )}
        onChange={setPartialDeckingFeatureId}
        value={partialDeckingFeatureId}
        disabled={archived}
      />
      <ManagedInput
        isValid={true}
        label={t(
          "component.forms.spec.partialDeckingPaddingLength",
          "Partial Decking Padding Length",
        )}
        type={"text"}
        placeholder={t(
          "component.forms.spec.partialDeckingPaddingLength",
          "Partial Decking Padding Length",
        )}
        onChange={setPartialDeckingPaddingLength}
        value={partialDeckingPaddingLength}
        disabled={archived}
      />
      <ManagedInput
        isValid={true}
        label={t(
          "component.forms.spec.partialDeckingPaddingFeatureId",
          "Partial Decking Padding FeatureId",
        )}
        type={"text"}
        placeholder={t(
          "component.forms.spec.partialDeckingPaddingFeatureId",
          "Partial Decking Padding FeatureId",
        )}
        onChange={setPartialDeckingPaddingFeatureId}
        value={partialDeckingPaddingFeatureId}
        disabled={archived}
      />
    </>
  );
};

export default PartialDeckingFeat;
